import { render, staticRenderFns } from "./CasualSend.vue?vue&type=template&id=68979f88&scoped=true&"
import script from "./CasualSend.vue?vue&type=script&lang=js&"
export * from "./CasualSend.vue?vue&type=script&lang=js&"
import style0 from "./CasualSend.vue?vue&type=style&index=0&id=68979f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68979f88",
  null
  
)

export default component.exports